export const VALID_PAGE_SIZES = [5, 10, 25, 50, 100];
